<template>
  <job-status
    :job-id="jobId"
    :model-value="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    @changed="$emit('changed', $event)"
  >
    <template v-slot="{ isLoading, success, failure }">
      <q-btn
        v-if="failure"
        icon="fa fa-exclamation"
        title="An error occurred while executing the search."
        color="negative"
        round
        flat
      />
      <q-btn
        v-else-if="isLoading || !success"
        icon="fa fa-spinner fa-spin"
        title="Searching posts..."
        round
        flat
      />
    </template>
  </job-status>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import JobStatus from '@/monitor/job/JobStatus.vue';
import { JobRun } from '@/type';

export default defineComponent({
  emits: ['changed', 'update:modelValue'],
  components: { JobStatus },
  props: {
    jobId: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Object as () => JobRun,
      default: null,
    },
  },
});
</script>
